import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ConsentService } from '../services/consent.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="consent-banner" *ngIf="consent.showBanner()" role="dialog" aria-label="Cookie consent">
      <span class="consent-text">
        This site uses cookies for analytics to help improve the experience and find bugs.
        No personal data is collected.
      </span>
      <div class="consent-actions">
        <button mat-button (click)="consent.decline()">Decline</button>
        <button mat-flat-button color="primary" (click)="consent.accept()">Accept</button>
      </div>
    </div>
  `,
  styles: [`
    .consent-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      padding: 14px 24px;
      background: var(--bg-card);
      border-top: 1px solid var(--border-card);
      box-shadow: 0 -2px 8px var(--shadow-card);
    }

    .consent-text {
      color: var(--text-secondary);
      font-size: 0.9rem;
      line-height: 1.4;
    }

    .consent-actions {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }

    @media (max-width: 600px) {
      .consent-banner {
        flex-direction: column;
        text-align: center;
        padding: 16px;
      }
    }
  `],
})
export class CookieConsentComponent {
  readonly consent = inject(ConsentService);
}
